import React from "react";
import lodash from "lodash";
import { Box, Grid, Typography } from "@material-ui/core";

export default function UnhandledBox(props) {
  /**
  |--------------------------------------------------
  | Handlers
  |--------------------------------------------------
  */
  function getRoundedSignalData() {
    const data = lodash.get(
      props.sensorDisplay,
      `analog.${props.analogKey}`,
      `no signal`
    );
    return typeof data !== "string" ? lodash.round(data, 2) : data;
  }

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <Box
      bgcolor="#C4C4C4"
      mr={1}
      mb={1}
      pb={3}
      width={{ xs: "70vw", md: "97%" }}
      height="95%"
      borderRadius="6px"
      style={{ opacity: "0.4" }}
    >
      <Grid container>
        <Grid item xs={12}>
          <div className="text-xs " style={{ color: "#625F5F" }}>
            <Typography align="center">{props.analogKey}</Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              color: "#303030",
              fontWeight: "bold",
              fontSize: "1.7em",
              marginTop: "40px",
            }}
          >
            {getRoundedSignalData()}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box color="grey.500">
            <Typography align="center">{props.item.unit}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
